module.exports = __webpack_public_path__ + "img/cm-rezistenta-prin-colind.515ea465.jpg";